import classNames from 'classnames';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import MediaQuery from 'react-responsive';
import QuestionIcon from '../icons/Question';
import './styles.css';

const InputLabel = ({
  className,
  label,
  subLabel,
  help,
  showHelpTooltip = true,
  children,
  contentClassName,
  ...props
}) => {
  const tooltipRef = useRef(null);
  const [tooltipPosition, setTooltipPosition] = useState('left');
  const [tooltipActive, setTooltipActive] = useState(false);
  const [tooltipHover, setTooltipHover] = useState(false);

  const checkTooltipPosition = useCallback(() => {
    if (!tooltipRef.current) {
      return;
    }

    const rect = tooltipRef.current.getBoundingClientRect();

    if (rect.left < 0 && tooltipRef.current.classList.contains('input-label__help-tooltip--left')) {
      setTooltipPosition('bottom');
    } else if (rect.left > rect.width && tooltipRef.current.classList.contains('input-label__help-tooltip--bottom')) {
      setTooltipPosition('left');
    }
  }, []);

  const showTooltip = useCallback(() => {
    if (!!help && showHelpTooltip && tooltipRef.current) {
      checkTooltipPosition();
      setTooltipActive(true);
    }
  }, [help, showHelpTooltip]);

  const hideTooltip = useCallback(() => {
    setTooltipActive(false);
  }, []);

  useEffect(() => {
    checkTooltipPosition();
  }, []);

  return (
    <div className={classNames('input-label', className, {
      'input-label--tooltip-hover': tooltipHover,
    })} {...props}>
      <div className={'input-label__content'}>
        {(!!label || (!!help && showHelpTooltip)) && (
          <div className={'input-label__text'}>
            {label}
            {!!help && showHelpTooltip && (
              <MediaQuery query={'(min-width: 769px)'}>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                  onFocus={showTooltip}
                  onBlur={hideTooltip}
                  onMouseEnter={() => setTooltipHover(true)}
                  onMouseLeave={() => setTooltipHover(false)}
                  className={'input-label__help-icon'}
                  type={'button'}
                >
                  <QuestionIcon size={20}/>
                </button>
              </MediaQuery>
            )}
          </div>
        )}
        {!!subLabel && (
          <div className={'input-label__sub-label'}>{subLabel}</div>
        )}
        <div className={classNames('input-label__inner', contentClassName)}>
          {!!help && showHelpTooltip && (
            <div
              ref={tooltipRef}
              className={classNames('input-label__help-tooltip', {
                'input-label__help-tooltip--left': tooltipPosition === 'left',
                'input-label__help-tooltip--bottom': tooltipPosition === 'bottom',
                'input-label__help-tooltip--active': tooltipActive,
              })}
            >
              {help}
            </div>
          )}
          {children}
        </div>
      </div>
      {help && showHelpTooltip && (
        <MediaQuery query={'(max-width: 768px)'}>
          <div className={'input-label__help'}>{help}</div>
        </MediaQuery>
      )}
      {help && !showHelpTooltip && (
        <div className={'input-label__help'}>{help}</div>
      )}
    </div>
  );
};

export default InputLabel;
